export const OPTHINES = {
    voteName: '2019poject/2019business',
    buttonBg: '#d83334',
    themeColor: {
        activeBgColor: 'rgb(194, 46, 46)',
        inactiveBgColor: '#999',
    },
    tabs: [
        {
            tabName: '活动详情',
            tabPath: '/2019CommercialBrand/Rules',
        },
        {
            tabName: '商业风云',
            tabPath: '/2019CommercialBrand/News',
        },

    ],
};
